import * as React from "react";
import { RadioButtonGroup, RadioButton } from "VSSUI/Components/RadioButton/RadioButton";
import { Checkbox } from "VSSUI/Components/Checkbox/Checkbox";
import { FollowType } from "WorkItemTracking/Scripts/Utils/FollowsUtils";
import WorkItemTrackingResources = require("WorkItemTracking/Scripts/Resources/TFS.Resources.WorkItemTracking");
import { CoreFieldRefNames } from "Presentation/Scripts/TFS/Generated/TFS.WorkItemTracking.Constants";

export interface CustomFollowDialogContentProps {
    currFollowType: FollowType;
    currCheckbox: string[];
    onSelectRadio: (select: FollowType) => void;
    onSelectCheckbox: (checkbox: string[]) => void;
}

export interface CustomFollowDialogContentState {
    selectedSubscriptionType: FollowType;
    selectedCheckbox: string[];
}

export class CustomFollowDialogContent extends React.Component<CustomFollowDialogContentProps, CustomFollowDialogContentState> {    
    public constructor(props: CustomFollowDialogContentProps) {
        super(props);
        this.state = {
            selectedSubscriptionType: this.props.currFollowType,
            selectedCheckbox: this.props.currCheckbox
        }
    }

    protected _handleSelect = (selectedId: string) : void => {
        if (selectedId === FollowType.All) {
            this.setState({
                selectedSubscriptionType: FollowType.All,
                selectedCheckbox: []
            });
            this.props.onSelectRadio(FollowType.All);
        }
        else if (selectedId === FollowType.Custom) {
            this.setState({
                selectedSubscriptionType: FollowType.Custom
            });
            this.props.onSelectRadio(FollowType.Custom);
        }
        else if (selectedId === FollowType.None) {
            this.setState({
                selectedSubscriptionType: FollowType.None,
                selectedCheckbox: []
            });
            this.props.onSelectRadio(FollowType.None);
        }
    }

    protected _handleCheckbox = (field: string, checked: boolean) :void => {
        if (this.state.selectedSubscriptionType === FollowType.Custom) {
            if (checked) {
                this.setState((state) => { 
                    const list = state.selectedCheckbox.concat(field);
                    this.props.onSelectCheckbox(list);
                    return {selectedCheckbox: list};
                });
            }
            else {
                this.setState((state) => { 
                    const list = state.selectedCheckbox.filter((item) => field !== item);
                    this.props.onSelectCheckbox(list);
                    return {selectedCheckbox: list};
                });
            }
        }
    }

    public render(): JSX.Element {
        return (<RadioButtonGroup
                onSelect={this._handleSelect}
                selectedButtonId={this.state.selectedSubscriptionType}>
                    <RadioButton id="None" text={WorkItemTrackingResources.CustomFollowDialogNoNotificationRadio} className="custom-radio-label"/>
                    <p className="custom-radio-label-description">{WorkItemTrackingResources.CustomFollowDialogNoNotificationRadioDescription}</p>
                    <RadioButton id="All" text={WorkItemTrackingResources.CustomFollowDialogAllNotificationsRadio} className="custom-radio-label"/>
                    <p className="custom-radio-label-description">{WorkItemTrackingResources.CustomFollowDialogAllNotificationsRadioDescription}</p>
                    <RadioButton id="Custom" text={WorkItemTrackingResources.CustomFollowDialogCustomNotificationRadio} className="custom-radio-label"/>
                    <p className="custom-radio-label-description">{WorkItemTrackingResources.CustomFollowDialogCustomNotificationRadioDescription}</p>
                    <div className="rhythm-vertical-8 flex-column custom-checkbox">
                        <Checkbox
                            onChange={(event, checked) => {this._handleCheckbox(CoreFieldRefNames.State, checked)}}
                            checked={this.state.selectedCheckbox.indexOf(CoreFieldRefNames.State) != -1}
                            label={WorkItemTrackingResources.CustomFollowDialogStateCheckbox}
                            disabled={this.state.selectedSubscriptionType != FollowType.Custom}
                        />
                        <Checkbox
                            onChange={(event, checked) => {this._handleCheckbox(CoreFieldRefNames.AssignedTo, checked)}}
                            checked={this.state.selectedCheckbox.indexOf(CoreFieldRefNames.AssignedTo) != -1}
                            label={WorkItemTrackingResources.CustomFollowDialogAssignedToCheckbox}
                            disabled={this.state.selectedSubscriptionType != FollowType.Custom}
                        />
                        <Checkbox
                            onChange={(event, checked) => {this._handleCheckbox(CoreFieldRefNames.IterationPath, checked)}}
                            checked={this.state.selectedCheckbox.indexOf(CoreFieldRefNames.IterationPath) != -1}
                            label={WorkItemTrackingResources.CustomFollowDialogIterationPathCheckbox}
                            disabled={this.state.selectedSubscriptionType != FollowType.Custom}
                        />
                    </div>
            </RadioButtonGroup>
        );
    }
}